export default {
      id: "clipboard-regular-usage",
      viewBox: "0 0 384 512",
      url: __webpack_public_path__ + "img/icons.792d8a78.svg#clipboard-regular-usage",
      toString: function () {
        return this.url;
      }
    }